import React, { useEffect, useState, useRef } from 'react';
import {connect} from 'react-redux';
import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import * as RestService from '../../services/eisRest';
import CustomSelect from '../../components/custom-select/CustomSelect';
import DatePicker, { registerLocale } from "react-datepicker";
import NumberFormat from 'react-number-format';
import sk from 'date-fns/locale/sk';
import PartnerModalWithDatatable from '../partner/PartnerModalWithDatatable';
import PartnerModal from '../partner/PartnerModal';
import CodeModal from '../code/CodeModal';
import DocumentModalWithDatatable from './DocumentModalWithDatatable';
import Item from './Item';


import DocumentPrint from './DocumentPrint';

import "react-datepicker/dist/react-datepicker.css";
registerLocale('sk', sk)




const DocumentTab = (props) => {

    
    const [t] = useTranslation();           

    const [entitySubName, setEntitySubName] = useState();
    const [entitySpecify, setEntitySpecify] = useState();
    const [transactionType, setTransactionType] = useState();
 //   const [selectedRecord, setSelectedRecord] =  useState(null);  

    const [document, setDocument] = useState();        
  //  const [invoice, setInvoice] = useState();    
    const [order, setOrder] = useState();    
    const [deliveryNote, setDeliveryNote] = useState();    
  //  const [initialData,setInitialData] = useState();
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [bill, setBill] = useState(null);
    const componentRef = useRef(null);
    
    const [documentText1Label, setDocumentText1Label] = useState('documentText1Label');    
    const [documentText2Label, setDocumentText2Label] = useState('documentText2Label');    
    const [documentText3Label, setDocumentText3Label] = useState('documentText3Label');    
    const [documentText4Label, setDocumentText4Label] = useState('documentText4Label');    

    const [documentDate1Label, setDocumentDate1Label] = useState('documentDate1Label');    
    const [documentDate2Label, setDocumentDate2Label] = useState('documentDate2Label');    
    const [documentDate3Label, setDocumentDate3Label] = useState('documentDate3Label');    
    
    
    const [documentDate1, setDocumentDate1] = useState(Date.now());
    const [documentDate2, setDocumentDate2] = useState(Date.now());
    const [documentDate3, setDocumentDate3] = useState(Date.now());
   

    const [visibleBankBlock, setVisibleBankBlock] = useState(false);
    const [visibleIbanBlock, setVisibleIbanBlock] = useState(false);
    
    
    const [visibleText1Block, setVisibleText1Block] = useState(false);
    const [visibleText2Block, setVisibleText2Block] = useState(false);
    const [visibleText3Block, setVisibleText3Block] = useState(false);
    const [visibleText4Block, setVisibleText4Block] = useState(false);

    const [visibleInvoiceOrBillBlock, setVisibleInvoiceOrBillBlock] = useState(false);
    const [visibleWarehouseIssBlock, setVisibleWarehouseIssBlock] = useState(false);
    const [visibleWarehouseRctBlock, setVisibleWarehouseRctBlock] = useState(false);
    

    const [visibleDate1Block, setVisibleDate1Block] = useState(false);
    const [visibleDate2Block, setVisibleDate2Block] = useState(false);
    const [visibleDate3Block, setVisibleDate3Block] = useState(false);


    const [documentText1ReadOnly, setDocumentText1ReadOnly] = useState(false);    
    const [documentText2ReadOnly, setDocumentText2ReadOnly] = useState(false);    
    const [documentText3ReadOnly, setDocumentText3ReadOnly] = useState(false);    
    const [documentText4ReadOnly, setDocumentText4ReadOnly] = useState(false);    

    const [documentDate1ReadOnly, setDocumentDate1ReadOnly] = useState(false);    
    const [documentDate2ReadOnly, setDocumentDate2ReadOnly] = useState(false);    
    const [documentDate3ReadOnly, setDocumentDate3ReadOnly] = useState(false);    
    
    const [otherSideEntitySubName, setOtherSideEntitySubName] = useState('company');    
    const [labelPartnerName, setLabelPartnerName] = useState('customer');
    
    const [showPartnerModalWithDatatable, setShowPartnerModalWithDatatable] = useState(false);
    const [showPartnerModal, setShowPartnerModal] = useState(false);

    const [showCodeModalWithDatatable, setShowCodeModalWithDatatable] = useState(false);
    const [showCodeModal, setShowCodeModal] = useState(false);
    const [codeList, setCodeList] = useState(false);
   
    const [totalAmountPriceExcludeVat, setTotalAmountPriceExcludeVat] = useState(0);
    const [totalAmountPriceIncludeVat, setTotalAmountPriceIncludeVat] = useState(0);
    

    const [partnerId, setPartnerId] = useState(null);
    const [loadedPartnerData, setLoadedPartnerData] = useState(null);
    const [ibanOptions, setIbanOptions] = useState([]);
    const [constantSymbolList, setConstantSymbolList] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [warehouseIssId, setWarehouseIssId] = useState(null);
    const [warehouseRctId, setWarehouseRctId] = useState(null);
    
    
    const [paymentOption,setPaymentOption] = useState('transfer_order');

    const [itemList, setItemList] = useState([]);
    const [checkTime, setCheckTime] = useState([]);
    
    const [partnerAddress, setPartnerAddress] = useState(null);
   
    const [showDocumentModalWithDatatable, setShowDocumentModalWithDatatable] = useState(false);   
    const [modalDocumentDatatableParameters, setModalDocumentDatatableParameters] = useState({
      entitySubName: '',
      entitySpecify: '',
      show: false
    });

    const partnerAddressT = {
       name: "",
       line1: "",
       line2: "",
       businessId: "",
       taxId: "",
       vatNo: ""
    }
     
    const yesNoOptions = [
      { value: 1, label:  t('general.label.yes')},
      { value: 0, label:  t('general.label.no')}                  
    ];
   
  
    const emptyItem = {        
      lineNumber: 0,
      active: true, 
      itemId: '',
      itemName: '',
      qty: 0,
      um: '',
      vat: 0,
      unitPriceExcludeVat: 0,
      unitPriceIncludeVat: 0,
      totalPriceExcludeVat: 0,
      totalPriceIncludeVat: 0,
      note: '',
      internalNote: '',
      serialNumberEnabled: 0,
      serialNumber: ''        
    };

    const paymentOptions = [
      { value: 'cash', label: t('document.label.cash') },
      { value: 'cash_on_delivery', label: t('document.label.cashOnDelivery') },            
      { value: 'credit_card', label: t('document.label.creditCard') },
      { value: 'transfer_order', label: t('document.label.transferOrder') },
      { value: 'customer_credit', label: t('document.label.customerCredit') },
    ];
    
    const handleBill = (e) => {
      setBill(Number(e.target.value));
    
    }
  

    const handleOpenPartnerList = () => {
     // console.log(showPartnerModalWithDatatable);
      setShowPartnerModalWithDatatable(null);
      setShowPartnerModalWithDatatable(true);
    }

    const handleOpenPartnerModal = () => {
      loadedPartnerData ? setShowPartnerModal(true) : setShowPartnerModal(false)
    }


   

    const handleOpenCodeModal = (cList) => {
      setCodeList('constant_symbol');
      setShowCodeModal(true);
    }

    const handleCallback = (show,id) => {               
      setShowPartnerModalWithDatatable(false);             
      getDataAboutPartnerData(id);
    };

    const handleCallbackDocumentModalWithDatatable = (show,id) => {         
      
             
      //documentText2          
     
                RestService.callAnyApi('document/getDocument?entitySubName='+modalDocumentDatatableParameters.entitySubName+"&entitySpecify="+modalDocumentDatatableParameters.entitySpecify+"&id="+id, null)
                .then((data) => {

                  

                  switch(entitySubName){
                    case "invoice":

                            switch(modalDocumentDatatableParameters.entitySubName){
                              case "order":                                
                                setOrder(data);  
                                formik.setFieldValue("documentText2",data.documentText1);        
                              break;
                              case "deliveryNote":
                                  setDeliveryNote(data);  
                                  formik.setFieldValue("documentText3",data.documentText1);        
                              break;
                            }

                    break;
                    case "deliveryNote":

                            switch(modalDocumentDatatableParameters.entitySubName){
                              case "order":
                                setDeliveryNote(data);  
                                formik.setFieldValue("documentText2",data.documentText1);        
                              break;                       
                            }

                    break;
                    
                  }
                  
     
                  getDataAboutPartnerData(data.partnerId,data.ibanId);
                  data.documentLines ? setItemList(data.documentLines) : setItemList([]) 
                  let newPartnerAddress = partnerAddressT;
 
                  if(data.address.partnerName===''){                       
                    newPartnerAddress.name = data.address.partnerFirstName+" "+data.address.partnerLastName;
                  }else{                   
                    newPartnerAddress.name =  data.address.partnerName;
                  }
                  newPartnerAddress.line1 = data.partnerAddressLine1;
                  newPartnerAddress.line2 = data.partnerAddressLine2;
                  newPartnerAddress.businessId =  data.address.partnerBusinessId;
                  newPartnerAddress.taxId = data.address.partnerTaxId;
                  newPartnerAddress.vatNo = data.address.partnerVatNo;
                  setPartnerAddress(newPartnerAddress);

                })
                .catch((error) => {
                  console.log(error);
                });
        
                setModalDocumentDatatableParameters({
                  entitySubName: '',
                  entitySpecify: '',
                  show: false
                });     
      
    };
    

    const handleOpenDocumentText2 = () => {

    
      if(entitySpecify==='INV-RCT'){

        setModalDocumentDatatableParameters({
          entitySubName: 'order',
          entitySpecify: 'ORD-ISS',
          show: true
        });

      }
      if(entitySpecify==='INV-ISS'){

        setModalDocumentDatatableParameters({
          entitySubName: 'order',
          entitySpecify: 'ORD-RCT',
          show: true
        });

      }

      if(entitySpecify==='DLN-RCT'){

        setModalDocumentDatatableParameters({
          entitySubName: 'order',
          entitySpecify: 'ORD-ISS',
          show: true
        });

      }
      if(entitySpecify==='DLN-ISS'){

        setModalDocumentDatatableParameters({
          entitySubName: 'order',
          entitySpecify: 'ORD-RCT',
          show: true
        });

      }
    }

   
    const handleOpenDocumentText3 = () => {

      if(entitySpecify==='INV-RCT'){

        setModalDocumentDatatableParameters({
          entitySubName: 'deliveryNote',
          entitySpecify: 'DLN-RCT',
          show: true
        });

      }
      if(entitySpecify==='INV-ISS'){

        setModalDocumentDatatableParameters({
          entitySubName: 'deliveryNote',
          entitySpecify: 'DLN-ISS',
          show: true
        });

      }

    }
  
    const addEmptyItem = () => {      
      let num=0;
      itemList.map((item,index) => {
        item.active=false;
        if(item.lineNumber>num){num=item.lineNumber;}
      });
   //   emptyItem.id = Date.now();
      emptyItem.lineNumber = num+1; //itemList.length+1;
      setItemList([...itemList, emptyItem]);
    }

    const getDataAboutPartnerData = (id,ibanId) => {
      RestService.callAnyApi('partner/getPartner?id='+id, null)
      .then((data) => {
        setLoadedPartnerData(data);  
        setPartnerId(data.id);
        if(props.entitySpecify!="INV-ISS"){
          
              let ibanOptions = [{}];
              if(data.bankAccountList!=null){
                  data.bankAccountList.map(function(item,i){
                      //console.log(item.id+" > "+item.iban);
                      ibanOptions.push({
                        value: item.id,
                        label: item.iban
                      });
                  });
              }
              setIbanOptions(ibanOptions);
              formik.setFieldValue('ibanId',ibanId);
        }
        
        formik.setFieldValue("findPartner",'');        
       
        let newPartnerAddress = partnerAddressT;
  
          if(data.address.name===''){
            formik.setFieldValue("findPartner",data.address.firstName+" "+data.address.lastName);        
            newPartnerAddress.name = data.address.firstName+" "+data.address.lastName;
          }else{
            formik.setFieldValue("findPartner",data.address.name);    
            newPartnerAddress.name =  data.address.name;
          }
          newPartnerAddress.line1 = data.address.street;
          newPartnerAddress.line2 = data.address.postalCode+" "+data.address.city+", "+data.address.country.iso;        
          newPartnerAddress.businessId =  data.address.businessId;
          newPartnerAddress.taxId = data.address.taxId;
          newPartnerAddress.vatNo = data.address.vatNo;
          setPartnerAddress(newPartnerAddress);
      })
      .catch((error) => {
        console.log(error);
      });
    }


    

    const clearForm = () => {
      
      setItemList([]);   
      setLoadedPartnerData(null);
      RestService.callAnyApi('document/getDocument?entitySubName='+props.entitySubName+"&entitySpecify="+props.entitySpecify+"&id=", null)
            .then((data) => {
                 setDocument(data);                  
            }).catch((error) => {    
                 toast.error(error);
            });
      setPartnerAddress(null);
      setPartnerId(null);
      formik.setFieldValue("findPartner","");
      formik.setFieldValue("documentText1","");
      formik.setFieldValue("documentText2","");
      formik.setFieldValue("documentText3","");
      formik.setFieldValue("documentText4","");
      setDocumentDate1(Date.now());
      setDocumentDate2(null);
      setDocumentDate3(null);
      formik.setFieldValue("ibanId",'');
      formik.setFieldValue("variableSymbol",'');
      formik.setFieldValue("constantSymbol",'');
      formik.setFieldValue("specificSymbol",'');
      formik.setFieldValue("documentDescription1",'');
      formik.setFieldValue("documentDescription2",'');          
      setTotalAmountPriceExcludeVat(0);
      setTotalAmountPriceIncludeVat(0);
      setBill(0);
    };
    
   

    const prepareForm = (entitySubName,entitySpecify) => {

          setVisibleBankBlock(false);

          setVisibleText1Block(false);
          setVisibleText2Block(false);
          setVisibleText3Block(false);
          setVisibleText4Block(false);

          setVisibleInvoiceOrBillBlock(false);
          setVisibleWarehouseIssBlock(false);
          setVisibleWarehouseRctBlock(false);

          setVisibleDate1Block(false);
          setVisibleDate2Block(false);
          setVisibleDate3Block(false);
         
          setDocumentText1ReadOnly(false);    
          setDocumentText2ReadOnly(false);    
          setDocumentText3ReadOnly(false);    
          setDocumentText4ReadOnly(false);    
      
          setDocumentDate1ReadOnly(false);    
          setDocumentDate2ReadOnly(false);    
          setDocumentDate3ReadOnly(false);    

          switch(entitySpecify){
                case "WRH-RCT":
                  setDocumentDate1Label(t('document.label.receiveDate'))
                  setVisibleDate1Block(true);
                  setDocumentDate1ReadOnly(true);
                 
                  setDocumentText1Label(t('document.label.receiveTicketNumber'));
                  setVisibleText1Block(true);
                  setDocumentText1ReadOnly(true);

                  setDocumentText2Label(t('document.label.orderNumber'));
                  setVisibleText2Block(true);
                  setDocumentText2ReadOnly(true);

                  setDocumentText3Label(t('document.label.receivedInvoiceNumber'));
                  setVisibleText3Block(true);
                  setDocumentText3ReadOnly(true);

                  setDocumentText4Label(t('document.label.cashReceipt'));
                  setVisibleText4Block(true);
                  setDocumentText4ReadOnly(true);
                  
                  setOtherSideEntitySubName("company");
                  setLabelPartnerName('Supplier');
                break; 

                case "WRH-ISS":
                  setDocumentDate1Label(t('document.label.issueDate'))
                  setVisibleDate1Block(true);
                  setDocumentDate1ReadOnly(true);

                  setDocumentDate2Label(t('document.label.orderDate'))
                  setVisibleDate2Block(true);
                  setDocumentDate2ReadOnly(true);
                 
                  setDocumentText1Label(t('document.label.issueTicketNumber'));
                  setVisibleText1Block(true);
                  setDocumentText1ReadOnly(true);

                  setDocumentText2Label(t('document.label.orderNumber'));
                  setVisibleText2Block(true);
                  setDocumentText2ReadOnly(true);

                  setDocumentText3Label(t('document.label.receivedInvoiceNumber'));
                  setVisibleText3Block(true);
                  setDocumentText3ReadOnly(true);

                  setDocumentText4Label(t('document.label.cashReceipt'));
                  setVisibleText4Block(true);
                  setDocumentText4ReadOnly(true);
                  
                  setOtherSideEntitySubName("company");
                  setLabelPartnerName('Customer');
                break; 

                case "INV-RCT":
                
                    setVisibleBankBlock(true);

                    setDocumentDate1Label(t('document.label.receiveDate'))
                    setVisibleDate1Block(true);
                    
                    setDocumentText1Label(t('document.label.receivedInvoiceNumber'));
                    setVisibleText1Block(true);
                   
                    setDocumentDate2Label(t('document.label.effectiveDate'))
                    setVisibleDate2Block(true);
  
                    setDocumentText2Label(t('document.label.purchaseOrderNumber'));
                    setVisibleText2Block(true);

                    setDocumentDate3Label(t('document.label.dueDate'))
                    setVisibleDate3Block(true);

                    setDocumentText3Label(t('document.label.deliveryNoteNumber'));
                    setVisibleText3Block(true);

                    setDocumentText4Label(t('document.label.accountingCode'));
                    setVisibleText4Block(true);

                    setOtherSideEntitySubName("supplier");
                    setLabelPartnerName('Supplier');
                    
                    setVisibleInvoiceOrBillBlock(true);
                    setVisibleWarehouseRctBlock(true);
                    setTransactionType('RCT-PO');

                break;


                case "INV-ISS":
                
                  setVisibleBankBlock(true);

                  setDocumentDate1Label(t('document.label.issueDate'))
                  setVisibleDate1Block(true);
                  setDocumentDate1ReadOnly(true);
                  
                  setDocumentText1Label(t('document.label.issuedInvoiceNumber'));
                  setVisibleText1Block(true);
                 
                  setDocumentDate2Label(t('document.label.effectiveDate'))
                  setVisibleDate2Block(true);               

                  setDocumentText2Label(t('document.label.orderNumber'));
                  setVisibleText2Block(true);

                  setDocumentDate3Label(t('document.label.dueDate'))
                  setVisibleDate3Block(true);

                  setDocumentText3Label(t('document.label.deliveryNoteNumber'));
                  setVisibleText3Block(true);

                  setDocumentText4Label(t('document.label.accountingCode'));
                  setVisibleText4Block(true);

                  setOtherSideEntitySubName("customer");
                  setLabelPartnerName('Customer');

                  setVisibleWarehouseIssBlock(true);
                  setTransactionType('ISS-SO');
              break;

              case "ORD-RCT":                                

                setDocumentDate1Label(t('document.label.receiveDate'))
                setVisibleDate1Block(true);
                
                setDocumentText1Label(t('document.label.salesOrderNumber'));
                setVisibleText1Block(true);                             

                setDocumentDate2Label(t('document.label.deadLine'))
                setVisibleDate2Block(true);
                
                setOtherSideEntitySubName("customer");
                setLabelPartnerName('Customer');
                
            break;


            case "ORD-ISS":
                             

              setDocumentDate1Label(t('document.label.issueDate'))
              setVisibleDate1Block(true);
              
              setDocumentText1Label(t('document.label.purchaseOrderNumber'));
              setVisibleText1Block(true);                           

              setDocumentDate2Label(t('document.label.deadLine'))
              setVisibleDate2Block(true);

              setOtherSideEntitySubName("supplier");
              setLabelPartnerName('Supplier');
              
            break;

            case "DLN-RCT":
                            

              setDocumentDate1Label(t('document.label.receiveDate'))
              setVisibleDate1Block(true);
              
              setDocumentText1Label(t('document.label.receivedDeliveryNoteNumber'));
              setVisibleText1Block(true);                           
              
              setDocumentText2Label(t('document.label.purchaseOrderNumber'));
              setVisibleText2Block(true);

              setOtherSideEntitySubName("supplier");
              setLabelPartnerName('Supplier');
              
            break;

            case "DLN-ISS":                           

              setDocumentDate1Label(t('document.label.issueDate'))
              setVisibleDate1Block(true);
              
              setDocumentText1Label(t('document.label.issuedDeliveryNoteNumber'));
              setVisibleText1Block(true);                           

             
              setDocumentText2Label(t('document.label.salesOrderNumber'));
              setVisibleText2Block(true);

              setOtherSideEntitySubName("customer");
              setLabelPartnerName('Customer');
              
            break;

          }
        
    
    }

    useEffect(() => {      
      setEntitySubName(props.entitySubName);
      prepareForm(props.entitySubName,entitySpecify);
    }, [props.entitySubName])


    useEffect(() => {      
      setEntitySpecify(props.entitySpecify);      
      prepareForm(entitySubName,props.entitySpecify);
    }, [props.entitySpecify])


    const loadConstantSymbolList = () => {
      RestService.callAnyApi('company/getCompanyCodeOptions?codeList=constant_symbol', null).then((data) => { setConstantSymbolList(data);}).catch((error) => {});                
    }

    useEffect(() => {
      loadConstantSymbolList();
      RestService.callAnyApi('warehouse/getWarehouseOptions', null).then((data) => { setWarehouseList(data);}).catch((error) => {});       
    }, []);

 
    

    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };


    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);          
    }


    const handleChangePaymentOption = (paymentOption) => {
      formik.setFieldValue('paymentOption',paymentOption); 
      setPaymentOption(paymentOption);

      if(paymentOption==='transfer_order'){
        setVisibleIbanBlock(true);
      }else{
        setVisibleIbanBlock(false);
      }
    }

    const apiOrder = (call) => {
        switch(call){         
          case "getDocument":
            RestService.callAnyApi('document/getDocument?entitySubName='+props.entitySubName+"&entitySpecify="+props.entitySpecify+"&id="+props.selectedRecord, null)
            .then((data) => {
                 //setVisibleBankBlock(false);
                 setDocument(data);    
                 setDocumentDate1(data.documentDate1);
                 setDocumentDate2(data.documentDate2);
                 setDocumentDate3(data.documentDate3);
                 setBill(data.bill);                 
                 handleChangePaymentOption(data.paymentOption);
                if(data.id==null){
                  switch(props.entitySpecify){
                    case "INV-ISS":
                       
                        setDocumentDate2(Date.now());

                        let ibanOptions = [{}];
                        if(props.company.bankAccountList!=null){
                            props.company.bankAccountList.map(function(item,i){
                                //console.log(item.id+" > "+item.iban);
                                ibanOptions.push({
                                  value: item.id,
                                  label: item.iban
                                });
                            });
                        }
                        setIbanOptions(ibanOptions);
                        formik.setFieldValue('ibanId',data.ibanId);                        
                        
                    break;
                  }
                }

                 getDataAboutPartnerData(data.partnerId,data.ibanId);
                 data.documentLines ? setItemList(data.documentLines) : setItemList([]) 
                 let newPartnerAddress = partnerAddressT;

                 if(data.address.partnerName===''){                       
                   newPartnerAddress.name = data.address.partnerFirstName+" "+data.address.partnerLastName;
                 }else{                   
                   newPartnerAddress.name =  data.address.partnerName;
                 }
                 newPartnerAddress.line1 = data.partnerAddressLine1;
                 newPartnerAddress.line2 = data.partnerAddressLine2;
                 newPartnerAddress.businessId =  data.address.partnerBusinessId;
                 newPartnerAddress.taxId = data.address.partnerTaxId;
                 newPartnerAddress.vatNo = data.address.partnerVatNo;
                 setPartnerAddress(newPartnerAddress);

                 
            })
            .catch((error) => {    
              toast.error(error);
            });
          break;          
        }

    }
   

    
    useEffect(() => {   
      setLoadedPartnerData(null);
      setDocument(null);
      setTotalAmountPriceExcludeVat(0);
      setTotalAmountPriceIncludeVat(0);
      apiOrder("getDocument");
    }, [props.selectedRecord])

  
  
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
      
      if(partnerId!=null){
         document.partnerId = partnerId;
      }
      document.entitySubName=entitySubName;
      document.entitySpecify=entitySpecify;
      document.documentText1 = values.documentText1;
      document.documentText2 = values.documentText2;
      document.documentText3 = values.documentText3;
      document.documentText4 = values.documentText4;
      document.documentDate1 = documentDate1;
      document.documentDate2 = documentDate2;
      document.documentDate3 = documentDate3;
      document.paymentOption = values.paymentOption;
      document.ibanId = values.ibanId;
      document.variableSymbol = values.variableSymbol;
      document.constantSymbol = values.constantSymbol;
      document.specificSymbol = values.specificSymbol;
      document.documentDescription1 = values.documentDescription1;
      document.documentDescription2 = values.documentDescription2;
      document.bill = bill;
      document.transactionType = transactionType;
      document.documentLines = itemList;

      RestService.callAnyApi(url,document)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          setDocument(data.responseObject); 
                          props.parentCallback(data.responseObject);
                          toast.success(t('general.message.saveSucceed'));                                                                      
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    

        findPartner : document ? document.partnerName : '' , 
        documentText1: document ? document.documentText1 : '',
        documentText2: document ? document.documentText2 : '',
        documentText3: document ? document.documentText3 : '',
        documentText4: document ? document.documentText4 : '',
        documentDate1: document ? document.documentDate1 : '',
        documentDate2: document ? document.documentDate2 : '',
        documentDate3: document ? document.documentDate3 : '',
        paymentOption: document ? document.paymentOption : 'transfer_order',
        bill: document ? document.bill : 0,
        ibanId : document ? document.ibanId : '',
        warehouseIssId:  document ? document.warehouseIssId : '',
        warehouseRctId:  document ? document.warehouseRctId : '',
        variableSymbol : document ? document.variableSymbol : '',
        constantSymbol : document ? document.constantSymbol : '',
        specificSymbol : document ? document.specificSymbol : '',
        documentDescription1: document ? document.documentDescription1 : '',
        documentDescription2: document ? document.documentDescription2 : '',
      },
      validationSchema: Yup.object({
      //   firstName: Yup.string()   
     //     .nullable()  
      //    .required(t('general.message.required')),
      
      }),
      onSubmit: (values) => {           
          save('document/saveDocument',values);         
      }
      
    });


    const itemCallback = (itemA,action) => {
       
      let num=0;
      itemList.map((item,index) => {      
        if(item.lineNumber>num){num=item.lineNumber;}
      });

       if(action==='edit'){
        itemList.map((item,index) => {
          if(itemA.lineNumber===item.lineNumber){
            //item = itemA;            
            item.active=true;
                                 
          }else{
            item.active=false;
          }
          
        });
      }

        if(action==='delete'){              
          const newList = itemList.filter((item) => item.lineNumber  !== itemA.lineNumber );
          if(newList.length>0){
            setItemList(newList);
            
          }else{
            setItemList([]);            
          }
          countTotalAmount(newList);
        }
        
        if(action==='copy'){
         
          itemList.map((item,index) => {           
              item.active=false;                      
          });
          const itemC = JSON.parse(JSON.stringify(itemA));
          itemC.lineNumber=num+1;
          itemC.active=true;        
          setItemList([...itemList,itemC]);
          countTotalAmount(itemList);
        }

        if(action!='copy' && action!='delete'){
          setItemList([...itemList]);
          countTotalAmount(itemList);
        }
       
       // setActiveItem(index);
    }


    const countTotalAmount = (itemList) => {

      let totalAmountPriceExcludeVatTemp=0;
      let totalAmountPriceIncludeVatTemp=0;

      if(itemList.length>0){
         itemList.map((item,index) => {
            totalAmountPriceExcludeVatTemp+=item.totalPriceExcludeVat;
            totalAmountPriceIncludeVatTemp+=item.totalPriceIncludeVat;        
         });
      }
      setTotalAmountPriceExcludeVat(totalAmountPriceExcludeVatTemp);
      setTotalAmountPriceIncludeVat(totalAmountPriceIncludeVatTemp);
    }

   
    const getItems = itemList.sort((a, b) => a.lineNumber > b.lineNumber ? 1 : -1).map((item,index) => {
    
      return (
      <Item 
        parentCallback={itemCallback}
        item={item}
        active={item ? item.active : false}
        checkTime={checkTime}
        entitySpecify={entitySpecify}
      />
      )
    });
 

    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
  

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
                      <form onSubmit={formik.handleSubmit}>     
                    

                      <div className="row text-muted">
          
    					  	  		      <div className="col-4 col-sm-4 col-lg-4">
    					  	  		
    					  	  			            <div className="row">
    					  	  				              
                                              <div className="col-7 col-sm-7 col-lg-7">
		    					  	  			
                                                        <div className="row">
		    					  	  				                            <div className="col-12 col-sm-12 col-lg-12 font-weight-bold">{document ? document.companyName : props.company.address.name}</div>	
		    					  	  			                          </div>
		    					  	  			                          
                                                        <div className="row">
		    					  	  				                            <div className="col-12 col-sm-12 col-lg-12">{document ? document.companyAddressLine1 : props.company.address.street}</div>	
		    					  	  			                          </div>
		    					  	  			                          
                                                        <div className="row">
		    					  	  				                            <div className="col-12 col-sm-12 col-lg-12">{document ? document.companyAddressLine2 :  props.company.address.country ? props.company.address.city + ', ' +props.company.address.country.iso : ''}</div>	
		    					  	  			                          </div>    					  	  			
		    					  	  			
                                                        <div className="row mt-1">
		    					  	  				                              <div className="col-12 col-sm-12 col-lg-12"></div>	
		    					  	  			                          </div>
		    					  	  			
                                                        <div className="row">
		    					  	  			                              	<div className="col-12 col-sm-12 col-lg-12">{t('general.label.businessId')}: {document ? document.companyBusinessId : props.company.address.businessId}</div>		    					  	  					
		    					  	  			                          </div>

                        		    					  	  			  <div className="row">
		    					  	                                				<div className="col-12 col-sm-12 col-lg-12">{t('general.label.taxId')}: {document ? document.companyTaxId : props.company.address.taxId}</div>		    					  	  		
		    					  	  			                          </div>

		    					  	  			                          <div className="row">
		    					  	  				                              <div className="col-12 col-sm-12 col-lg-12">{t('general.label.vatNo')}: {document ? document.companyVatNo : props.company.address.vatNo}</div>    					  	  				
		    					  	  			                          </div>
    					  	  				                  </div>
    					  	  				
                                              <div className="col-5 col-sm-5 col-lg-5">
    					  	  					
                                                        <div className="row"  style={visibleText4Block ? {} : { display: 'none' }}>
    					  	  						
                                                            <div className="form-group">
                    									                        <label style={{marginRight: '5px'}}>{documentText4Label}</label>                    					
                    									                        <input type="text" className="form-control col-12 col-sm-12 col-lg-12"  {...formik.getFieldProps('documentText4')} placeholder="" />                    					
                  									                        </div>

    					  	  					                          </div>    

                                                        <div className="row"  value={handleBill} onChange={handleBill} style={visibleInvoiceOrBillBlock ? {} : { display: 'none' }}>
                                                        
                                                          
                                                            
                                                                  <div className="col-6 col-sm-6 col-lg-6">
                                                                      <input type="radio" name="cashReceipt" value="0" checked={bill === 0} /> {t('document.label.invoice')}
                                                                  </div>
                                                                  <div className="col-6 col-sm-6 col-lg-6">
                                                                      <input type="radio" name="cashReceipt" value="1" checked={bill === 1} /> {t('document.label.bill')}
                                                                  </div>
                                                            
                                                         </div>                                                                  

    					  	  				                  </div>
    					  	  			            </div>

    					  	  			            <div className="row" style={visibleBankBlock ? {marginRight: '7px'} : { display: 'none' }}>

    					  	  				                  <div className="col-12 col-sm-12 col-lg-12" style={{marginLeft: '7px',  marginTop: '10px', marginBottom: '5px', backgroundColor: '#F7F8F9', borderRadius: '5px'}}>
    					  	  					
                                                      <div className="row" style={{paddingTop: '5px', paddingBottom: '3px'}}>
    					  	  						                          
                                                            <div className="col-4 col-sm-4 col-lg-4 text-right" style={{paddingTop: '3px'}}>{t('document.label.methodOfPayment')}:</div>
    					  	  						                                  
                                                                    <div className="col-8 col-sm-8 col-lg-8">                        									                                  
                                                                    <CustomSelect
                                                                        className='input'
                                                                        onChange={value=> { handleChangePaymentOption(value.value)}}
                                                                        value={formik.values.paymentOption}
                                                                        options={paymentOptions}     
                                                                    />                            										
    					  	  						                                    </div>

    					  	  					                              </div>
    					  	  					
    					  	  					                              <span  style={visibleIbanBlock ?  {} : { display: 'none' } }>
    					  	  					
    					  	  					                                  <div className="row"  style={{paddingBottom: '3px'}}>
    					  	  						                                        
                                                                        <div className="col-4 col-sm-4 col-lg-4 text-right">{t('bankAccount.label.iban')}:</div>
    					  	  						                                        <div className="col-6 col-sm-6 col-lg-6" >    					  	  							       									
                                                                        <CustomSelect
                                                                            className='input'
                                                                            onChange={value=>formik.setFieldValue('ibanId',value.value)}
                                                                            value={formik.values.ibanId}
                                                                            options={ibanOptions}     
                                                                        />                            									                   										            										              										       
                                            					  	  						</div>
    					  	  						
                                                                        <div className="col-2 col-sm-2 col-lg-2" style={{marginTop: '7px'}} >
    					  	  							                                          
                                                                            <div className="row">
    					  	  								
                                                                                  <div className="col-5 col-sm-5 col-lg5" style={{marginTop: '2px'}} id="addNewIban" >
    					  	  										                                              <i className="fa fa-plus-circle fa-lg" aria-hidden="true" onClick={handleOpenPartnerModal} ></i>
    					  	  								                                              </div>    					  	  								                                           
    					  	  							                                          </div>

    					  	  						                                        </div>
    					  	  						
    					  	  					                                  </div> 

    					  	  					                                  <div className="row"  style={{paddingBottom: '3px'}}>
    					  	  						
                                                                        <div className="col-4 col-sm-4 col-lg-4 text-right" >{t('document.label.variableSymbol')}:</div>
    					  	  			                                                
                                                                          			<div className="col-5 col-sm-5 col-lg-5">
													                                                            <input type="text" className="form-control" {...formik.getFieldProps('variableSymbol')} />
													                                                      </div>                    					

    					  	  					                                          </div>
    					  	  					                                          
                                                                        <div className="row" style={{paddingBottom: '5px'}}>
    					  	  						
                                                                              <div className="col-4 col-sm-4 col-lg-4 text-right" style={{paddingTop: '3px'}}>{t('document.label.constantSymbol')}:</div>
    					  	  						                                              <div className="col-5 col-sm-5 col-lg-5">

                                                                              <CustomSelect
                                                                                  className='input'
                                                                                  onChange={value=>formik.setFieldValue('constantSymbol',value.value)}
                                                                                  value={formik.values.constantSymbol}
                                                                                  options={constantSymbolList}     
                                                                              />                                      										
    					  	  						                                        </div>

    					  	  						                                        <div className="col-2 col-sm-2 col-lg-2" style={{marginTop: '7px'}}>
    					  	  							                                            
                                                                              <div className="row">
    					  	  								
                                                                                    <div className="col-5 col-sm-5 col-lg5" style={{marginTop: '2px'}} id="addNewConstantSymbol" >
    					  	  										                                                <i className="fa fa-plus-circle fa-lg" aria-hidden="true"onClick={handleOpenCodeModal} ></i>
    					  	  								                                                </div>    					  	  								

    					  	  							                                            </div>

    					  	  						                                        </div>
    					  	  					                                  </div>

    					  	  					                                  <div className="row" style={{paddingBottom: '5px'}}>

    					  	  						                                        <div className="col-4 col-sm-4 col-lg-4 text-right" style={{paddingTop: '3px'}}>{t('document.label.specificSymbol')}:</div>
    					  	  						                                                  
                                                                                  <div className="col-5 col-sm-5 col-lg-5">
                        								                                                <input type="text" className="form-control" {...formik.getFieldProps('specificSymbol')} />                               										
    					  	  						                                                  </div>    					  	  						
    					  	  					                                                  
                                                                        </div>
    					  	  					
    					  	  					                              </span>
    					  	  					
    					  	  				                          </div>	

    					  	  			                    </div>
    					  	  		              </div>
    					  			
    					  			                <div className="col-4 col-sm-4 col-lg-4">
    		    					  	  			                  
    					  	  			                    <div className="row">
    					  	  				
                                                    <div className="col-5 col-sm-5 col-lg-5" style={visibleDate1Block ? {} : { display: 'none' }}>
    					  	  					                            
                                                          <div className="form-group">

                  								                            <label>{documentDate1Label}</label>                  								                            
                                                             
                    								                              <DatePicker
                                                                      className='form-control '                                       
                                                                      selected={documentDate1}
                                                                      onChange={(value) => setDocumentDate1(new Date(value).getTime())}
                                                                      dateFormat="dd.MM.yyyy"                                                                              
                                                                  />      
                  								                           
                                                          </div>
                								                          

    					  	  				                        </div>

    					  	  				                        <div className="col-7 col-sm-7 col-lg-7"  style={visibleText1Block ? {} : { display: 'none' }}>

    					  	  					                            <div className="form-group">

                    								                            <label style={{marginRight: '5px'}}>{documentText1Label}</label>                    					
                    								                            <input type="text" className="form-control col-12 col-sm-12 col-lg-12"  {...formik.getFieldProps('documentText1')}  placeholder="" />                    					

                  								                        </div>
    					  	  				                        </div>	

    					  	  			                    </div>

    					  	  			                    <div className="row">
    					  	  				
                                                    <div className="col-5 col-sm-5 col-lg-5"  style={visibleDate2Block ? {} : { display: 'none' }}>
    					  	  					
                                                          <div className="form-group">
                  								
                                                                <label>{documentDate2Label}</label>
                  								                             
                    								                                             								
                                                                    <DatePicker
                                                                      className='form-control'                                       
                                                                      selected={documentDate2}
                                                                      onChange={(value) => setDocumentDate2(new Date(value).getTime())}
                                                                      dateFormat="dd.MM.yyyy"                                                                              
                                                                    /> 
                  								                             

                								                          </div> 

    					  	  				                        </div>

    					  	  				                        <div className="col-7 col-sm-7 col-lg-7"  style={visibleText2Block ? {} : { display: 'none' }}>
    					  	  					                                                         

                                                          <label  style={{marginright: '5px'}}>{documentText2Label}</label>   
                                                          <div className="input-group mb-3 find-item">                                                              
                                                              <div className="input-group-prepend">
                                                                      <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                              </div>                                                                                                                            
                                                              <input type="text" className="form-control col-12 col-sm-12 col-lg-12" readOnly onClick={handleOpenDocumentText2}  {...formik.getFieldProps('documentText2')} placeholder={t('document.label.find')} />
                                                          </div>

                        					  	  				    </div>

                                                </div>
                                                <div className="row">

    					  	  				                        <div className="col-5 col-sm-5 col-lg-5"  style={visibleDate3Block ? {} : { display: 'none' }}>
    					  	  					
                                                          <div className="form-group">
                  								
                                                                <label>{documentDate3Label}</label>
                  								                             
                    								                                <DatePicker
                                                                      className='form-control'                                       
                                                                      selected={documentDate3}
                                                                      onChange={(value) => setDocumentDate3(new Date(value).getTime())}
                                                                      dateFormat="dd.MM.yyyy"                                                                              
                                                                    /> 
                  								                             
                                                                
                								                          </div> 

    					  	  				                        </div>

    					  	  				                        <div className="col-7 col-sm-7 col-lg-7"  style={visibleText3Block ? {} : { display: 'none' }}>
    					  	  					                                                         

                                                          <label style={{marginright: '5px'}}>{documentText3Label}</label>    
                                                          <div className="input-group mb-3 find-item">                                                              
                                                              <div className="input-group-prepend">
                                                                      <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                              </div>                                                                                                                            
                                                              <input type="text" className="form-control col-12 col-sm-12 col-lg-12" readOnly onClick={handleOpenDocumentText3}  {...formik.getFieldProps('documentText3')} placeholder={t('document.label.find')} />
                                                          </div>

    					  	  				                        </div>	

    					  	  			                    </div>    					  	  			
    					  	  		              </div>
    					  			
    					  			                <div className="col-4 col-sm-4 col-lg-4">    					  	  		
    					  	  			
                                          <div className="row">
    					  	  				
                                                <div className="col-12 col-sm-12 col-lg-12">
			          								
                                                       <label>{t('document.label.find'+labelPartnerName)}:</label>
                                                       <div className="input-group mb-3 find-item">                                                              
                                                              <div className="input-group-prepend">
                                                                      <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                              </div>                                                                                                                            
                                                              <input type="text" className="form-control col-12 col-sm-12 col-lg-12" readOnly onClick={handleOpenPartnerList}  {...formik.getFieldProps('findPartner')} placeholder={t('document.label.findPartner') } />
                                                      </div>
                                              
                                                      
  													                          

    					  	  		 		                    </div>        					  	  		 						  	  		 	                			
    					  	  			                </div>

    					  	  			                <div className="row" style={{marginTop: '22px', paddingLeft: '7px', paddingRight: '7px'}}>
    					  	  		 		                      
                                                   <div className="col-12 col-sm-12 col-lg-12" style={{fontWeight: 'bold', backgroundColor: '#e3e3e3', borderRadius: '5px'}}>{t('document.label.'+labelPartnerName)}</div>                                                   

    					  	  			                </div>	

                    					  	  			<div className="row">
												
                                                  <div className="col-12 col-sm-12 col-lg-12" style={ partnerAddress && partnerAddress.name ? {} : {visibility: 'hidden'}}>
    					  	  						                          
                                                          <div className="col-12 col-sm-12 col-lg-12" style={{marginTop: '5px'}}>			          
															                            
                                                          <div className="row">
                            																	<div className="col-12 col-sm-12 col-lg-12 font-weight-bold" >{partnerAddress ? partnerAddress.name  : ''}</div>	
															                            </div>
															                            
                                                          <div className="row mt-1">
																	                            <div className="col-12 col-sm-12 col-lg-12" >{partnerAddress ? partnerAddress.line1 : ''}</div>	
															                            </div>
															                            
                                                          <div className="row">
																	                            <div className="col-12 col-sm-12 col-lg-12">{partnerAddress ? partnerAddress.line2 : ''}</div>	
															                            </div>
															
                                                          <div className="row mt-1">
																	                            <div className="col-12 col-sm-12 col-lg-12"></div>	
															                            </div>
															
                                                          <div className="row">
																	                            <div className="col-12 col-sm-12 col-lg-12">{t('general.label.businessId')}: {partnerAddress ? partnerAddress.businessId : ''}</div>																	                            
															                            </div>

															                            <div className="row">
                                                              <div className="col-12 col-sm-12 col-lg-12">{t('general.label.taxId')}: {partnerAddress ? partnerAddress.taxId : ''}</div>																	                            
															                            </div>

															                            <div className="row">
                                                              <div className="col-12 col-sm-12 col-lg-12">{t('general.label.vatNo')}: {partnerAddress ? partnerAddress.vatNo : ''}</div>																	                            	
															                            </div>

													                        </div>							  				
												              </div>
											          </div>    					  				
    					  			    </div>    	
    					  			
    					  	     </div>
    					      					  	 
    					        <div className="row text-muted">
    					  	  
		    					          	<div className="col-6 col-sm-6 col-lg-6">
    					  	  		          <input type="text" className="form-control col-12 col-sm-12 col-lg-12" {...formik.getFieldProps('documentDescription1')}  placeholder={t('document.label.upperDescription')} />
    					  	  		      </div>    
                              <div className="col-6 col-sm-6 col-lg-6" style={visibleWarehouseIssBlock ? {} : { display: 'none' }}>
                                    <div className="row">
                                           <div className="col-6 col-sm-6 col-lg-6 text-right font-weight-bold" style={{paddingTop: '7px'}}>
                                                {t('document.label.removalItemsFrom')}:
                                            </div>                  
                                            <div className="col-6 col-sm-6 col-lg-6">
                                           <CustomSelect
                                                   className='input'
                                                   onChange={value=> {formik.setFieldValue('warehouseIssId',value.value); setWarehouseIssId(value.value)}}
                                                   value={formik.values.warehouseIssId}
                                                   options={warehouseList}     
                                           />   					  	  		
                                           </div>
                                    </div>
                              </div>
                              <div className="col-6 col-sm-6 col-lg-6" style={visibleWarehouseRctBlock ? {} : { display: 'none' }}>
                                    <div className="row">
                                           <div className="col-6 col-sm-6 col-lg-6 text-right font-weight-bold" style={{paddingTop: '7px'}}>
                                                {t('document.label.stackingItemsIn')}:
                                            </div>                  
                                            <div className="col-6 col-sm-6 col-lg-6">
                                           <CustomSelect
                                                   className='input'
                                                   onChange={value=> {formik.setFieldValue('warehouseRctId',value.value); setWarehouseRctId(value.value)}}
                                                   value={formik.values.warehouseRctId}
                                                   options={warehouseList}     
                                           />   					  	  		
                                           </div>
                                    </div>
                              </div>
                			</div>

    					  	
    					  	    <div className="row text-muted" style={{marginLeft: '1px', marginRight: '1px', marginTop: '5px', fontSize: '10px', backgroundColor: '#e3e3e3', borderRadius: '5px'}}>
    					  	 
    					  	  	    	<div className="col-5 col-sm-5 col-lg-5">{t('document.label.item')}</div>
    					  	  		    <div className="col-1 col-sm-1 col-lg-1">{t('document.label.qty')}</div>
    					  	  		    <div className="col-1 col-sm-1 col-lg-1">{t('document.label.um')}</div>
    					  	  		    <div className="col-1 col-sm-1 col-lg-1">{t('document.label.vat')} %</div>
    					  	  		    <div className="col-1 col-sm-1 col-lg-1"><span>{t('document.label.priceExcludeVat')}</span><br/><span>{t('document.label.priceIncludeVat')}</span></div>
    					  	  		    <div className="col-1 col-sm-1 col-lg-1"><span>{t('document.label.totalExcludeVat')}</span><br/><span>{t('document.label.priceIncludeVat')}</span></div>
    					  	  		    <div className="col-2 col-sm-2 col-lg-2">{t('document.label.actions')}</div>				

                			</div>

             
                			<div className="row text-muted" style={{marginTop: '5px'}}></div>
    					  	 
    					  	         
                                {getItems}                                 
                			     
    					  	  
                					  	  <div className="row" style={{marginTop: '10px'}}>
    				              
                          	  	  	<div className="col-12 col-sm-12 col-lg-12">    					  	  		
                                          <button type="button" className="btn btn-default" onClick={addEmptyItem}><i className="fas fa-plus"></i></button>
    					  	  	              </div>

    					  	              </div>

    					  	              <div className="row">
    					  	  	                 
    					  	  					                
                                              <div className="col-6 col-sm-6 col-lg-6" ></div>    					  	  	    					  	  					               
                                              <div className="col-2 col-sm-2 col-lg-2" style={{fontWeight: 'bold',marginTop: '7px', textAlign: 'right'}}>{t('document.label.totalAmount')}:</div>    					  	  	    					  	  					               
                                              <div className="col-1 col-sm-1 col-lg-1">
                                                  <NumberFormat displayType="text" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'} value={totalAmountPriceExcludeVat} />                                            
                                              </div>
    					  	  					                <div className="col-1 col-sm-1 col-lg-1">
                                                  <NumberFormat displayType="text" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'} value={totalAmountPriceIncludeVat} />                                            
                                              </div>
    					  	  					                <div className="col-2 col-sm-2 col-lg-2"></div>

    					  	  	          
    					  	              </div>

    						      <div className="row text-muted" style={{marginTop: '10px',marginBottom: '20px'}}>
    					  	  
		    					  	          <div className="col-12 col-sm-12 col-lg-12" style={{paddingRight: '10px'}}>
    					  	  		            <input type="text" className="form-control col-12 col-sm-12 col-lg-12" {...formik.getFieldProps('documentDescription2')} placeholder={t('document.label.lowerDescription')} />
    					  	  		        </div>
                			</div>






                 









                        <div className="card-footer">
                            <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>     
                            <Button className="btn-default float-right" onClick={clearForm}>{t('general.button.clearForm')}</Button>                                                        	            	       			
                            <Button className="btn-default float-right" onClick={handlePrint}>{t('general.button.print')}</Button>  
                  			</div>



                      </form>
                      <PartnerModalWithDatatable         
                          parentCallback={handleCallback}    
                          modal={showPartnerModalWithDatatable}                                
                      />
                      <PartnerModal 
                          show={showPartnerModal}                        
                          selectedRecord={loadedPartnerData ? loadedPartnerData.id : ''}                  
                          partnerType={props.partnerType}   
                          parentCallback={() => {}}            
                      />                      
                       <CodeModal 
                          modal={showCodeModal}
                          parentCallback={() => {loadConstantSymbolList() }}                           
                          codeList={codeList}         
                      />
                       <DocumentModalWithDatatable         
                          parentCallback={handleCallbackDocumentModalWithDatatable}    
                          modal={modalDocumentDatatableParameters.show}   
                          entitySubName={modalDocumentDatatableParameters.entitySubName}   
                          entitySpecify={modalDocumentDatatableParameters.entitySpecify}   
                          showSelectEntitySpecify={false}    
                          checkTime={Date.now()}                       
                      />
                    
                    <div style={{ display: "none" }}>
                          <DocumentPrint 
                            ref={componentRef}
                            document={document}
                       
                          />
                      </div>
        </div>
    );
};


const mapStateToProps = (state) => ({
  company: state.company.currentCompany
});


export default connect(mapStateToProps,null)(DocumentTab);